// import React from "react";

// const ThreeDPrintCalculator = () => {
//   return (
//     <div style={{marginTop:"80px", maxWidth: "800px", margin: "40px auto", textAlign: "center" }}>
//       <h2>3D Printing Cost Calculator</h2>
//       <p>Use this calculator to estimate the cost of your 3D print job.</p>
      
//       <iframe
//         src="https://3dpcalc.vercel.app/"
//         width="100%"
//         height="700"
//         frameBorder="0"
//         style={{ border: "1px solid #ccc", borderRadius: "8px", marginTop: "20px" }}
//         title="3D Printing Calculator"
//       ></iframe>
//     </div>
//   );
// };

// export default ThreeDPrintCalculator;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./3dprinting.css";

const ComingSoonPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();

  useEffect(() => {
    // Show popup automatically on page load
    const timer = setTimeout(() => setShowPopup(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
     navigate("/");
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="popup-close" onClick={closePopup}>
              ×
            </button>
            <h2 className="popup-title">🚀 Coming Soon</h2>
            <p className="popup-text">
              We’re working on something exciting! Stay tuned.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ComingSoonPopup;

